import type { TransformableTheme } from '../contexts/TransformableContext';

// Default theme with original styling
export const defaultTheme: TransformableTheme = {
  element: {
    outline: '1px solid #007bff',
    borderRadius: '0px',
    backgroundColor: '#007bff20',
  },
  resizeHandlers: {
    base: {
      backgroundColor: 'white',
      outline: '1px solid #007bff',
      borderRadius: 0,
      width: 8,
      height: 8,
    },
    topLeft: {},
    top: {},
    topRight: {},
    right: {},
    bottomRight: {},
    bottom: {},
    bottomLeft: {},
    left: {},
  },
  rotationHandler: {
    base: {
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: 0,
      width: 8,
      height: 8,
    },
    topLeft: {},
    topRight: {},
    bottomRight: {},
    bottomLeft: {},
  },
  origin: {
    position: 'absolute',
    width: '5px',
    height: '5px',
    backgroundColor: '#007bff',
    outline: '1px solid #fff',
    borderRadius: '50%',
    pointerEvents: 'none',
    zIndex: 10001,
  },
};
